import BlocksList from './BlocksList';

export default BlocksList;
